import React from "react";
import { Field, FieldArray, reduxForm } from "redux-form";
import { Form } from "antd";
import { renderField } from "utils/forms";

import "react-widgets/dist/css/react-widgets.css";

//antd
import { Button, Col, Row, Select } from "antd";

const statusOptions = [
  { text: "Yes", value: true },
  { text: "No", value: false }
];

export const renderSelectField = (
  { input, label, type, name, placeholder, meta: { touched, error, warning } },
  options
) => (
  <Form.Item
    validateStatus={touched && error ? "error" : ""}
    help={(touched && error) || ""}
  >
    <Select {...input} onChange={input.onChange} placeholder={label} required>
      <Select.Option disabled selected value="">
        {label}
      </Select.Option>
      {statusOptions.map((statusOption, i) => {
        return (
          <Select.Option key={i} value={statusOption.value}>
            {statusOption.text}
          </Select.Option>
        );
      })}
    </Select>
  </Form.Item>
);

const renderInterviewers = ({ fields, meta: { touched, error } }) => (
  <div>
    <div>
      <Row>
        <Col span={8}>
          <span className="bold">Selected for interviews:</span>
        </Col>
        <Col span={6}>
          <span className="bold">Offer Made:</span>
        </Col>
        <Col span={6} offset={2}>
          <span className="bold">Offer Accepted:</span>
        </Col>
      </Row>
    </div>
    {fields.map((interview, index) => (
      <div key={index}>
        <div>
          <Row>
            <Col span={6}>
              <Field
                name={`${interview}.company_name`}
                type="text"
                component={renderField}
                label="Company Name"
                style={{ margin: 0 }}
              />
            </Col>
            <Col span={6} offset={2}>
              <Field
                name={`${interview}.offer_made`}
                component={renderSelectField}
                style={{ marginBottom: 0, marginTop: "4px" }}
              />
            </Col>
            <Col span={6} offset={2}>
              <Field
                name={`${interview}.offer_accepted`}
                component={renderSelectField}
                style={{ marginBottom: 0 }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={3}>
              <Button
                htmlType="submit"
                type="primary"
                style={{ marginTop: "4px" }}
              >
                Save
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    ))}
    {touched && error && <span>{error}</span>}
    <br />
    <h3>
      <a onClick={() => fields.push({})}>Add Post Challenge Interview</a>
    </h3>
  </div>
);

let PostChallengeInterviewForm = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <FieldArray name="interviews" component={renderInterviewers} />
      </Row>
    </form>
  );
};

export default reduxForm({
  form: "PostChallengeInterviewForm-edit"
})(PostChallengeInterviewForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/student/forms/interview.js